import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { createTheme, CssBaseline, Stack, ThemeProvider } from '@mui/material';
import { lazy, Suspense, useMemo } from 'react';
import { withTranslation } from 'react-i18next';
import { ErrorBoundary } from './components/ErrorBoundary';
import './scss/style-overides.scss';
import globalStyles from './scss/styles.module.scss';
import PageLoading from './components/Layout/PageLoading';
import { BlacklistProvider } from './context/blacklist';
import { DesignByCategoriesProvider } from './context/designByCategories';

const App = ({ t }: { t: (key: string) => string }) => {
    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: 'light',
                    primary: {
                        main: '#040037',
                        light: '#B3B2C2',
                    },
                    success: {
                        main: '#4caf50',
                    },
                    warning: {
                        main: '#ffc400',
                    },
                    error: {
                        main: '#c13515',
                    },
                    info: {
                        main: '#b3b2c2',
                    },
                },
            }),
        []
    );

    const HomePage = lazy(() => import('./pages/home/HomePage'));
    const EmbroideryPage = lazy(
        () => import('./pages/embroidery/EmbroideryPage')
    );
    const PrintPage = lazy(() => import('./pages/print/PrintPage'));
    return (
        <ThemeProvider theme={theme}>
            <DesignByCategoriesProvider>
                <BlacklistProvider>
                    <CssBaseline />
                    <ErrorBoundary>
                        <Stack
                            height="100%"
                            className={globalStyles.bodyContainer}
                        >
                            <Suspense fallback={<PageLoading />}>
                                <BrowserRouter
                                    basename={process.env.PUBLIC_URL}
                                >
                                    <Routes>
                                        <Route
                                            path="/"
                                            element={
                                                <Navigate to="/home" replace />
                                            }
                                        />

                                        <Route
                                            path="/home"
                                            element={<HomePage translate={t} />}
                                        />
                                        <Route
                                            path="/embroidery"
                                            element={
                                                <EmbroideryPage translate={t} />
                                            }
                                        />
                                        <Route
                                            path="/print"
                                            element={
                                                <PrintPage translate={t} />
                                            }
                                        />
                                    </Routes>
                                </BrowserRouter>
                            </Suspense>
                        </Stack>
                    </ErrorBoundary>
                </BlacklistProvider>
            </DesignByCategoriesProvider>
        </ThemeProvider>
    );
};

export default withTranslation()(App);
